


<div  class="{{input1.isMandatory?'bo-form-group-required':''}}" [attr.data-tooltip]="input1.description?input1.description:null">

  <label for  class="text-uppercase text-bold text-violet ">{{input1.label}}</label>

  <input  #refEl *ngIf="text_or_email_or_number_input(input1)"  (blur)="checkvalidity(refEl,input1)" (change)="change(refEl,input1)" class="form-control  {{!input1.isValid && input1.touched ?'is-invalid':''}}" type="{{input1.inputType}}" required="{{input1.isMandatory}}" name="{{input1.label+''+input1.id}}"  [(ngModel)]="input1.value">

  <textarea style="padding: 10px" *ngIf="input1.inputType.toLowerCase() =='textarea'" id="{{'input'+input1.id}}"   class="form-control  {{!input1.isValid && input1.touched ?'is-invalid':''}}" rows="4" cols="50" (blur)="checkTextareavalidity(refEl,input1)" required="{{input1.isMandatory}}" name="{{input1.label+''+input1.id}}"  [(ngModel)]="input1.value">

  </textarea>

  <!--file-->
  <div *ngIf="inputIsImage(input1)">
    <div class="input-file" (click)="trigerFileInput()">
      <img src="assets/imgs/icon.jpg"  style="width: 42px;margin-right: 26px;" alt="fileIcone">
      {{'Télécharger votre fichier'}}
      <i class="fa fa-check" *ngIf="uploadSuccess"> </i>
    </div>
  </div>

  <div *ngIf="inputIsPdf(input1)">
    <div class="input-file" (click)="trigerFileInput()">
      <img src="assets/imgs/icon.jpg"  style="width: 42px;margin-right: 26px;" alt="fileIcone">
      {{'Télécharger votre fichier'}}
      <i class="fa fa-check" *ngIf="uploadSuccess"> </i>
    </div>
  </div>

  <div *ngIf="inputIsZip(input1)">
    <div class="input-file" (click)="trigerFileInput()">
      <img src="assets/imgs/icon.jpg"  style="width: 42px;margin-right: 26px;" alt="fileIcone">
      {{'Télécharger votre fichier'}}
      <i class="fa fa-check" *ngIf="uploadSuccess"> </i>
    </div>
  </div>

  <input *ngIf="inputIsImage(input1)"  id="{{'input'+input1.id}}"   (change)="inputImagesChangeListener($event)" type="{{input1.inputType}}" required="{{input1.isMandatory}}" name="{{input1.label}}" style="visibility:hidden;">

  <input *ngIf="inputIsPdf(input1)"  id="{{'input'+input1.id}}"   (change)="inputPdfChangeListener($event)" type="{{input1.inputType}}" required="{{input1.isMandatory}}" name="{{input1.label}}" style="visibility:hidden;">

  <input *ngIf="inputIsZip(input1)"  id="{{'input'+input1.id}}"   (change)="inputZipChangeListener($event)" type="{{input1.inputType}}" required="{{input1.isMandatory}}" name="{{input1.label}}" style="visibility:hidden;">

  <!--input telephone-->
 <!-- (change)="telInputChange(input1)"-->
  <input  #refEl *ngIf="input1.inputType.toLowerCase() == 'tel'"
          class="form-control {{!input1.isValid && input1.touched ?'is-invalid':''}} oinput"
          type="tel"
          ng2TelInput
          (hasError)="hasError($event,error)"
          (ng2TelOutput)="getNumber($event,number)"
          (intlTelInputObject)="telInputObject($event,objec)"
          (countryChange)="onCountryChange($event,code)"
          name="{{input1.label}}"
          required="{{input1.isMandatory}}"/>



  <select *ngIf="input1.inputType.toLowerCase() == 'countryselect'" (focus)="countryselectFocuse()" (change)="countryselectChange()" class="form-control" name="{{input1.label+input1.id}}" id="{{input1.id}}" [(ngModel)]="input1.value">
    <option [value]='null'>Choississez un pays</option>
    <option *ngFor="let p of countries" [value]="p.translations.fr">{{p.translations.fr}}</option>
  </select>


  <select *ngIf="input1.inputType.toLowerCase() == 'unikchoice'" (focus)="selectFocuse()" (change)="selectChange()" class="form-control" name="{{input1.label+input1.id}}" id="{{input1.id}}" [(ngModel)]="input1.value">
    <option [value]='null'>Choississez</option>
    <option *ngFor="let answ of input1.possible_answers" [value]="answ">{{answ}}</option>
  </select>


<ng-container *ngIf="input1.inputType == 'checkbox'">
   <div class="addons-wrapper unset-padding">
    <div class="addons-content flexible unset-padding" *ngFor="let answ of input1.possible_answers">
        <input  [value]="answ"   id="{{'input'+input1.id}}"   (change)="checkboxonChange(answ, $event.target.checked)"    type="{{input1.inputType}}" required="{{input1.isMandatory}}" name="{{input1.label}}" >
        <label class="prevent-required"> {{answ}} </label>
    </div>
  </div>
</ng-container>


  <ng-container *ngIf="input1.inputType == 'radio'">
    <div class="addons-wrapper unset-padding">
      <div class="addons-content flexible unset-padding" *ngFor="let answ of input1.possible_answers">
        <input  [value]="answ"   id="{{'input'+input1.id}}"   (change)="radioonChange(answ, $event.target.checked)"    type="{{input1.inputType}}" required="{{input1.isMandatory}}" name="{{input1.label}}" >
        <label class="prevent-required"> {{answ}} </label>
      </div>
    </div>
  </ng-container>

  <!-- validation message-->

  <div *ngIf="inputIsSelection(input1)" >
    <span style="font-size: 12px;color: red" *ngIf="!input1.isValid && input1.isMandatory && input1.touched">ce champs est obligatoire</span>
  </div>

  <div *ngIf="input1.inputType == 'checkbox'">
    <span style="font-size: 12px;color: red" *ngIf="!input1.isValid && input1.isMandatory && input1.touched">ce champs est obligatoire</span>
  </div>

  <div *ngIf="input1.inputType == 'file'">
    <span style="font-size: 12px;color: red" *ngIf="!input1.isValid && input1.isMandatory && input1.touched">Vous devez télécharger un fichier</span>
  </div>


 <div *ngIf="text_or_email_or_number_input(input1)">
  <span style="font-size: 12px;color: red" *ngIf="!input1.isValid && input1.touched && input1.value.length<=0">ce champs est obligatoire</span>
  <span style="font-size: 12px;color: red" *ngIf="!input1.isValid && input1.touched && input1.value.length > 0">format non valide</span>
 </div>

  <div  *ngIf="input1.inputType == 'textarea'">
    <span style="font-size: 12px;color: red" *ngIf="!input1.isValid && input1.touched && input1.value.length<=0">ce champs est obligatoire</span>
  </div>

 <div *ngIf="input1.inputType == 'tel'">
    <span style="font-size: 12px;color: red" *ngIf="input1.touched && input1.isMandatory && !input1.value && !input1.isValid">champs obligatoire ou format non valide</span>
    <span style="font-size: 12px;color: red" *ngIf="input1.touched && !input1.isMandatory && telInputError">format non valide</span>
 </div>

</div>
